var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"0px","padding-top":"0px"},attrs:{"id":"app"}},[_c('router-view'),_c('Modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }